import {
    server
} from "@/api";


export const admin = {
    agents: async (params) => {
        return await server().get('api/dashboard/admin/agents', { params })
    },

    followups: async (params) => {
        return await server().get('api/dashboard/admin/followups', { params })
    },

    overview: async (params) => {
        return await server().get('api/dashboard/admin/overview', { params })
    },
    
    dailyNewOrders: async (params) => {
        return await server().get('api/dashboard/admin/daily-new-orders', { params })
    },

    dailyConfirmedOrders: async (params) => {
        return await server().get('api/dashboard/admin/daily-confirmed-orders', { params })
    },

    dailyDeliveredOrders: async (params) => {
        return await server().get('api/dashboard/admin/daily-delivered-orders', { params })
    }
}


export const agent = {
    performance: async (params) => {
        return await server().get('api/dashboard/agent/performance', { params })
    },

    dailyDroppedOrders: async (params) => {
        return await server().get('api/dashboard/agent/daily-dropped-orders', { params })
    },

    dailyTreatedOrders: async (params) => {
        return await server().get('api/dashboard/agent/daily-treated-orders', { params })
    },

    dailyConfirmedOrders: async (params) => {
        return await server().get('api/dashboard/agent/daily-confirmed-orders', { params })
    },

    dailyDeliveredOrders: async (params) => {
        return await server().get('api/dashboard/agent/daily-delivered-orders', { params })
    },

    topProducts: async (params) => {
        return await server().get('api/dashboard/agent/top-products', { params })
    }

}

export default {
    admin,
    agent
}